import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/qa-tools/')({
  component: () => <Navigate to="/qa-tools/dev-configs" />,
});
